<style lang="scss" scoped>
.d-flex > * {
  margin: 0 10px;
}
</style>

<template>
  <div class="d-flex">
    <slot :query="query">
      No Filter define
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      query: {}
    };
  },
  created() {
    this.query = this.value;
  },
  watch: {
    query: {
      deep: true,
      handler() {
        this.$emit("input", this.query);
        this.$emit("change");
      }
    }
  }
};
</script>
